var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoPadel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 97.5775,
    height: 26.0977,
    viewBox: "0 0 97.5775 26.0977",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union",
    filter: "url(#filter0_ii_822_8973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6096 0C16.4735 3.50783e-05 18.275 0.261573 19.8703 0.951172C21.4684 1.62415 22.8483 2.69686 23.7853 4.23633C23.8148 4.28482 23.8439 4.33394 23.8722 4.38281C24.0943 4.76488 24.6634 4.80682 24.8986 4.43262L26.5187 1.85449L26.5881 1.74707C27.3228 0.657171 28.5533 0.000141807 29.8732 0H33.3224C35.0328 6.69415e-05 36.5467 1.09724 37.0832 2.71484L37.1076 2.79199L39.049 9.06836C39.2199 9.62104 40.0196 9.56435 40.1105 8.99316L41.009 3.34082L41.0236 3.25098C41.3659 1.37263 43.0041 6.31497e-05 44.9221 0H51.3967C55.1399 7.0668e-06 58.5519 0.864871 61.1447 3.0752C61.1484 3.07829 61.1518 3.08187 61.1554 3.08496C61.1569 3.08617 61.1589 3.08766 61.1603 3.08887C61.3599 3.25818 61.5512 3.43256 61.7346 3.61133C62.024 3.89339 62.5356 3.74574 62.5988 3.34668L62.6135 3.25586C62.9537 1.37523 64.593 8.79345e-07 66.5129 0H79.1252C79.7877 0 80.4076 0.161352 80.9513 0.444336C81.1398 0.542418 81.3663 0.542251 81.5549 0.444336C82.1032 0.159642 82.7244 6.98032e-05 83.3781 0H87.5197C89.9538 0.000155952 91.8125 2.17455 91.4338 4.5791L89.9045 14.2891C89.8523 14.6207 90.1088 14.9209 90.4445 14.9209H93.6135C96.0473 14.9209 97.9065 17.0947 97.5285 19.499L97.0168 22.751C96.7137 24.678 95.0533 26.0975 93.1027 26.0977H80.4914C79.8284 26.0976 79.2082 25.9367 78.6642 25.6533C78.4757 25.5551 78.2494 25.5544 78.0607 25.6523C77.5119 25.9376 76.89 26.0976 76.2355 26.0977H63.6515C62.0965 26.0977 60.7762 25.2103 60.1242 23.9424C59.9469 23.5982 59.4936 23.4456 59.1721 23.6611C58.3392 24.2205 57.437 24.6883 56.4767 25.0674L56.4592 25.0742L56.4406 25.0811C54.5894 25.7874 52.5589 26.0976 50.4133 26.0977H42.0353C41.5669 26.0977 41.1192 26.0174 40.7053 25.8701C40.566 25.8207 40.4138 25.8207 40.2746 25.8701C39.8614 26.0171 39.4131 26.0976 38.9416 26.0977H35.1056C33.2972 26.0976 31.718 24.8735 31.2678 23.1221L31.1554 22.6826C31.0934 22.4412 30.8754 22.2727 30.6262 22.2725H27.4103C27.2162 22.2725 27.0366 22.3753 26.9387 22.543L26.0129 24.1309C25.303 25.3487 23.9997 26.0975 22.59 26.0977H18.4543C15.3378 26.0976 13.4409 22.6662 15.0988 20.0273C15.2482 19.7894 15.0569 19.4814 14.7765 19.5C14.37 19.5269 13.9584 19.5391 13.5431 19.5391H12.9924C12.7239 19.5393 12.4955 19.7348 12.4533 20L12.0168 22.7549C11.712 24.6801 10.0519 26.0977 8.10271 26.0977H3.96307C1.52667 26.0976 -0.332268 23.9199 0.0499804 21.5137L2.9367 3.34082C3.24241 1.41667 4.90152 0.000171206 6.84979 0H14.6096Z",
    fill: "#304D95"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PADEL",
    filter: "url(#filter1_d_822_8973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M82.8474 3.71471H87.2888C87.35 3.71471 87.397 3.76954 87.3875 3.82995L85.1824 17.8299C85.1158 18.2526 85.442 18.6354 85.8699 18.6356H93.3836C93.4445 18.6359 93.4907 18.6906 93.4812 18.7508L92.9236 22.2997C92.9158 22.3479 92.8738 22.3837 92.825 22.3837H79.9138C79.8527 22.3837 79.8057 22.3288 79.8152 22.2684L82.7498 3.7987C82.7574 3.75043 82.7986 3.71481 82.8474 3.71471Z",
    fill: "url(#paint0_linear_822_8973)",
    stroke: "white",
    strokeWidth: 0.597217
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M65.9825 3.71471H78.8956C78.9564 3.71499 79.0024 3.76891 78.9933 3.82897L78.4894 7.05065C78.4816 7.09891 78.4396 7.13463 78.3907 7.13463H70.3546C70.0118 7.13467 69.7196 7.38389 69.6661 7.72252L69.2452 10.3973C69.1788 10.8201 69.5057 11.202 69.9337 11.202H77.0909C77.152 11.202 77.199 11.2569 77.1896 11.3173L76.6866 14.5106C76.679 14.559 76.637 14.5946 76.588 14.5946H69.1515C68.8093 14.5947 68.5181 14.8436 68.464 15.1815L67.9894 18.1571C67.922 18.5801 68.2486 18.9634 68.6769 18.9637H76.463C76.524 18.9637 76.5708 19.0178 76.5616 19.078L76.0577 22.2997C76.05 22.3479 76.008 22.3836 75.9591 22.3837H63.0743C63.0132 22.3837 62.9663 22.3288 62.9757 22.2684L65.8839 3.7987C65.8915 3.7503 65.9335 3.71471 65.9825 3.71471Z",
    fill: "url(#paint1_linear_822_8973)",
    stroke: "white",
    strokeWidth: 0.597217
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M44.3913 3.71471H50.9929C54.2112 3.71471 56.6466 4.46076 58.3415 5.911L58.3425 5.91198C60.0333 7.3413 60.897 9.32125 60.9147 11.8895C60.9145 13.4051 60.6742 14.8082 60.196 16.1014L60.195 16.1034C59.7359 17.3748 59.0391 18.4761 58.1052 19.41L58.1032 19.412C57.3024 20.2282 56.3376 20.8921 55.2048 21.4022L54.7126 21.6102C53.3689 22.123 51.8028 22.3836 50.0095 22.3837H41.4577C41.3966 22.3837 41.3496 22.3288 41.3591 22.2684L44.2937 3.7987C44.3013 3.75043 44.3425 3.71481 44.3913 3.71471ZM48.9548 7.35338C48.6125 7.3535 48.3212 7.60221 48.2673 7.9403L46.6726 17.9383C46.6051 18.3615 46.9317 18.7448 47.3601 18.745H50.0642C51.024 18.7449 51.8834 18.594 52.6364 18.285L52.6403 18.284C53.4089 17.9574 54.0493 17.4928 54.5554 16.8895C55.0569 16.2916 55.4302 15.5815 55.6774 14.7655C55.9434 13.9297 56.0739 12.9966 56.0739 11.9696C56.0739 10.6003 55.7052 9.49826 54.9333 8.70592L54.7741 8.55163C53.8969 7.73558 52.6186 7.35338 50.9929 7.35338H48.9548Z",
    fill: "url(#paint2_linear_822_8973)",
    stroke: "white",
    strokeWidth: 0.597217
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M30.2909 3.71471H33.4179C33.6361 3.71475 33.829 3.85684 33.8934 4.0653L39.3583 21.7391C39.4569 22.0591 39.2177 22.3837 38.8827 22.3837H35.2704C35.225 22.3837 35.185 22.3525 35.1737 22.3085L34.3446 19.0809C34.2655 18.773 33.9877 18.5576 33.6698 18.5575H25.6415C25.3938 18.5576 25.1647 18.6892 25.0399 18.9032L23.0409 22.3339C23.0231 22.3644 22.9894 22.3837 22.954 22.3837H19.1854C18.7942 22.3834 18.5564 21.9523 18.7645 21.621L29.87 3.94713C29.961 3.80245 30.12 3.71484 30.2909 3.71471ZM31.3231 8.55553C31.2329 8.55553 31.1475 8.59146 31.0849 8.65319L31.0302 8.7235L27.8827 14.0878C27.6102 14.5522 27.9458 15.1376 28.4843 15.1376H32.4149C32.8718 15.1376 33.2049 14.7053 33.0888 14.2635L31.6513 8.80846L31.6317 8.75475C31.5853 8.65223 31.4907 8.57925 31.3798 8.56041L31.3231 8.55553Z",
    fill: "url(#paint3_linear_822_8973)",
    stroke: "white",
    strokeWidth: 0.597217
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.34234 3.71471H14.8882C16.4473 3.71471 17.7149 3.93924 18.7037 4.37291L18.7076 4.37389C19.6969 4.79045 20.4184 5.39035 20.8912 6.16686C21.3678 6.94997 21.6128 7.89679 21.6128 9.01842C21.6128 10.4895 21.3123 11.7294 20.7242 12.7499L20.7232 12.7508C20.1565 13.7468 19.2963 14.5078 18.1275 15.0311L18.1265 15.0321C16.9733 15.5563 15.5423 15.8251 13.8228 15.8251H10.5679C10.0295 15.8251 9.57028 16.2161 9.48589 16.7479L8.6607 21.9637C8.62233 22.2054 8.41326 22.3837 8.16851 22.3837H4.53472C4.22879 22.3836 3.99551 22.1096 4.04351 21.8075L6.85113 4.13366C6.88969 3.89227 7.09787 3.71483 7.34234 3.71471ZM11.9341 7.13463C11.3955 7.13471 10.9372 7.52642 10.8531 8.05846L10.3668 11.1395C10.2621 11.8039 10.7752 12.4051 11.4478 12.4051H14.0142C15.0193 12.4051 15.8318 12.1779 16.399 11.6737L16.4029 11.6698C16.9717 11.1431 17.2369 10.3973 17.2369 9.48229C17.2368 8.70432 16.9831 8.08124 16.4293 7.68248H16.4283C15.9135 7.29929 15.1443 7.13467 14.1783 7.13463H11.9341Z",
    fill: "url(#paint4_linear_822_8973)",
    stroke: "white",
    strokeWidth: 0.597217
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_822_8973",
    x: 0,
    y: -0.398145,
    width: 97.5775,
    height: 26.8939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.597217
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.199072
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.37 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_822_8973"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.398145
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.497681
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.126966 0 0 0 0 0.2478 0 0 0 0 0.547799 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_822_8973",
    result: "effect2_innerShadow_822_8973"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_822_8973",
    x: 2.54398,
    y: 3.41588,
    width: 92.0337,
    height: 21.4559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.199072,
    dy: 1.19443
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.497681
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.108852 0 0 0 0 0.23178 0 0 0 0 0.536983 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_822_8973"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_822_8973",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_822_8973",
    x1: 86.6479,
    y1: 3.41588,
    x2: 86.6479,
    y2: 22.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F3F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E4E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_822_8973",
    x1: 70.9845,
    y1: 3.41588,
    x2: 70.9845,
    y2: 22.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F3F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E4E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_822_8973",
    x1: 51.1022,
    y1: 3.41588,
    x2: 51.1022,
    y2: 22.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F3F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E4E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_822_8973",
    x1: 28.8537,
    y1: 3.41588,
    x2: 28.8537,
    y2: 22.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F3F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E4E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_822_8973",
    x1: 12.7569,
    y1: 3.41588,
    x2: 12.7569,
    y2: 22.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F3F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E4E5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPadel);
export default __webpack_public_path__ + "static/media/logo_padel.057e76017f003e78ddfb8d4c6dcf3038.svg";
export { ForwardRef as ReactComponent };